import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { CreatePayableDialogComponent } from './create-payable-dialog.component';
import { CreatePayableDialogStateService } from './create-payable-dialog-state.service';

@Component({
    selector: 'app-create-payable-dialog-host',
    standalone: true,
    imports: [NgIf, CreatePayableDialogComponent],
    template: '<app-create-payable-dialog *ngIf="state.open()" [open]="state.open()" [data]="state.data()" (closed)="state.answer($event)"></app-create-payable-dialog>',
})
export class CreatePayableDialogHostComponent
{
    constructor(readonly state: CreatePayableDialogStateService) {}
}
